import {
    SEND_USAGE_REPORT,
    SEND_USAGE_REPORT_SUCCESS,
    SEND_USAGE_REPORT_FAILURE,
    RESET_SEND_USAGE_REPORT_STATUS,
} from '../actions';

const initialState = {
    loading: false,
    statusCode: '',
    statusMessage: '',
    isSendReportReset: false,
};

const SendReportReducer = (state = initialState, action) => {
    switch (action.type) {
        case SEND_USAGE_REPORT:
            return {
                ...state,
                loading: true,
            };
        case SEND_USAGE_REPORT_SUCCESS:
            return {
                ...state,
                loading: false,
                ...action.data,
            };
        case SEND_USAGE_REPORT_FAILURE:
            return {
                ...state,
                loading: false,
            };
        case RESET_SEND_USAGE_REPORT_STATUS:
            return {
                ...state,
                ...action.payload,
            };
        default:
            return {
                ...state,
            };
    }
};

export default SendReportReducer;
